import { EventIdentifier, FeatureTeamEvent, TrackingEventType, useAnalytics } from '@capsicum/common';
import { useCallback } from 'react';

export const useTrackUKRegulationEvents = () => {
	const analytics = useAnalytics();

	const trackUKBannerClick = useCallback(() => {
		analytics.sendEvent(TrackingEventType.track, EventIdentifier.UKRegulationBannerClick, {
			feature_team: FeatureTeamEvent.KRFT,
			text: `UK banner click`
		});
	}, [analytics, FeatureTeamEvent]);

	const trackUKRiskWarningLinkClick = useCallback(() => {
		analytics.sendEvent(TrackingEventType.track, EventIdentifier.UKRegulationLearnMoreLinkClick, {
			feature_team: FeatureTeamEvent.KRFT,
			text: `UK Risk Warning Link Click`
		});
	}, [analytics, FeatureTeamEvent]);

	const trackUKRiskWarningDecline = useCallback(() => {
		analytics.sendEvent(TrackingEventType.track, EventIdentifier.UKRegulationRiskWarningDecline, {
			feature_team: FeatureTeamEvent.KRFT,
			text: `UK Risk Warning decline`
		});
	}, [analytics, FeatureTeamEvent]);

	return {
		trackUKBannerClick,
		trackUKRiskWarningDecline,
		trackUKRiskWarningLinkClick
	};
};
